import { ButtonTriggerEvent } from '../../../../common/components';
import { Account } from '../../../../models/admin/account';

export class ToggleFeaturesModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class ToggleFeaturesModalData {
    account: Account;
    constructor(account?) {
        this.account = account;
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/toggle.features/toggle.features.modal.provider.ts